<template lang="pug">
	.audio-tracker-shortcuts
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :width="480", :autosize="true", classes="tracker-dark")
			.audio-tracker-shortcuts.flex-col.space-large
				.group.flex-col.space(v-for="group in groupedShortcuts")
					.font-large.group-name {{group.name}}
					.flex-col
						.shortcut.flex-row.justify.align-center.space-medium(v-for="shortcut in group.items")
							.flex-col.space
								span {{shortcut.description}}
							.flex-row.space.align-center
								template(v-for="(comb, idx) in shortcut.combination")
									span(v-if="idx > 0") +
									.cmp-item(v-if="comb.cmp && !comb.keys")
										component(:is="comb.cmp", :style="{ width: `${comb.width}px` }")
									template(v-if="comb.keys") 
										template(v-for="(key, keyIdx) in comb.keys")
											span(v-if="keyIdx > 0") {{$tCaption('or')}}
											.flex-row.space.align-center.center(:class="{ 'shortuct-item': !comb.cmp }")
												.cmp-item(v-if="comb.cmp")
													component(:is="comb.cmp", :style="{ width: `${comb.width}px` }")
												span {{key}}
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
	import _ from 'lodash';
	import Popup from 'app-core/Popup.vue';
	import MouseWheelIcon from 'assets/mouse-scroll-wheel-icon.svg';
	import MouseLBIcon from 'assets/mouse-left-click-icon.svg';
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'audioTracker.AudioTrackerShortcuts',
		name: 'audio-tracker-shortcuts',
		components: { Popup, DxButton },
		props: {},
		data() {
			return {
				popupVisible: false,
				shortcuts: [
					{
						combination: [
							{
								keys: ['SPACE']
							}
						],
						description: this.$tCaption('Play/Stop'),
						group: this.$tCaption('Playing')
					},
					{
						combination: [
							{
								keys: ['BACKSPACE']
							}
						],
						description: this.$tCaption('Backward'),
						group: this.$tCaption('Playing')
					},
					{
						combination: [
							{
								keys: ['CTRL']
							},
							{
								cmp: MouseWheelIcon,
								width: 25
							}
						],
						description: this.$tCaption('Zoom in/out'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['SHIFT']
							},
							{
								cmp: MouseLBIcon,
								width: 29
							}
						],
						description: this.$tCaption('Multiselect'),
						group: this.$tCaption('Clips')
					},
					{
						combination: [
							{
								keys: ['+','=']
							}
						],
						description: this.$tCaption('Zoom in'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['-']
							}
						],
						description: this.$tCaption('Zoom out'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['TAB']
							}
						],
						description: this.$tCaption('Next beat'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['W']
							}
						],
						description: this.$tCaption('Track above'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['S']
							}
						],
						description: this.$tCaption('Track below'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['A']
							}
						],
						description: this.$tCaption('Previous clip/start on the active track'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['D']
							}
						],
						description: this.$tCaption('Next clip/end on the active track'),
						group: this.$tCaption('Navigation')
					},
					{
						combination: [
							{
								keys: ['CTRL']
							},
							{
								keys: ['RESIZE CLIP'],
								cmp: MouseLBIcon,
								width: 15
							}
						],
						description: this.$tCaption('Change rate on Voice clip'),
						group: this.$tCaption('Clips')
					},
					{
						combination: [
							{
								keys: ['CTRL']
							},
							{
								keys: ['UP']
							}
						],
						description: this.$tCaption('Use previous track for speech'),
						group: this.$tCaption('Speech streaming')
					},
					{
						combination: [
							{
								keys: ['CTRL']
							},
							{
								keys: ['DOWN']
							}
						],
						description: this.$tCaption('Use next track for speech'),
						group: this.$tCaption('Speech streaming')
					}
				]
			};
		},
		computed: {
			groupedShortcuts() {
				const groups = _.groupBy(this.shortcuts, f => f.group);

				return Object.keys(groups).map(f => ({
					name: f,
					items: groups[f]
				}));
			}
		},
		watch: {

		},
		mounted() {
			if (__DEBUG__)
				window.audioTrackerShortcuts = this;
		},
		beforeDestroy() {
			
		},
		methods: {
			show() {
				this.popupVisible = false;
				this.$nextTick(() => {
					this.popupVisible = true;
				});
			}
		}
	};
</script>
<style lang='scss'>
	.audio-tracker-shortcuts {
		@import "main/themes/generated/variables.base.scss";

		.shortuct-item{
			padding: 7px 12px;
			background: rgba(255,255,255,0.05);
			border-radius: 4px;
			min-width: 38px;
			min-height: 38px;
			box-shadow: 0px 1px 0px 0px #333, 0px 0px 0px 3px rgba(0,0,0,0.05);
			border: 1px solid rgba(255,255,255,0.03);
		}

		.shortcut {
			border-radius: 4px;
			padding: 4px 8px;

			&:hover {
				background: rgba(255,255,255,0.1);
			}
		}

		.group-name {
			padding-bottom: 4px;
			border-bottom: 1px solid rgba(255,255,255,0.1);
		}
	}
</style>
